import React, { FC } from 'react';
import MediaPreview from 'app/components/MediaPreview';
import { Field, TextInput } from '@kontentino/ui';

type Props = {
  src?: string;
  orderIndex?: number;
  loadingProgress?: number;
  withDescriptionField?: boolean;
};

const EditableLinkCardSkeleton: FC<Props> = ({
  orderIndex,
  loadingProgress,
  src,
  withDescriptionField,
}) => {
  return (
    <>
      <div className="tw-relative tw-flex tw-gap-6 tw-rounded tw-bg-grayscale-5 tw-p-4">
        <div>
          <MediaPreview
            isLoading={true}
            orderIndex={orderIndex}
            src={src}
            loadingProgress={loadingProgress}
          />
        </div>
        <div className="tw-flex-1">
          <div className="tw-flex tw-flex-col tw-gap-4">
            <Field.Group>
              <Field.Label required>Title</Field.Label>
              <TextInput placeholder="Title" disabled={true} />
            </Field.Group>
            {withDescriptionField && (
              <Field.Group>
                <Field.Label required>Description</Field.Label>
                <TextInput placeholder="Description" disabled />
              </Field.Group>
            )}
            <Field.Group>
              <Field.Label required>Link</Field.Label>
              <TextInput prefix={'https://'} disabled />
            </Field.Group>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditableLinkCardSkeleton;
